import React, { useEffect, useMemo } from 'react';
import Layout from './Layout';
import { AVATAR_UPDATED, Person, useEventsSubscriber, usePeopleService } from 'nekst-api';


export function AvatarInput(props: {
  person: Person,
}) {

  const [updatedAvatar, setUpdatedAvatar] = React.useState<{
    value: {
      resized: string,
      full: string,
    } | undefined
  }>();


  useEffect(() => {
    setUpdatedAvatar(undefined);
  }, [props.person.id]);

  const personService = usePeopleService();

  const refreshAvatar = async () => {
    const newData = await personService.getById(props.person.id);

    setUpdatedAvatar({
      value: newData.profile._avatarUrl,
    });
  }

  useEventsSubscriber('AvatarInput', {
    [AVATAR_UPDATED]: refreshAvatar,
  });

  const personData = useMemo(() => {
    return{
      ...props.person,
      profile: {
        ...props.person.profile,
        _avatarUrl: updatedAvatar ? updatedAvatar.value : props.person.profile._avatarUrl,
      }
    }
  }, [props.person.id, JSON.stringify(updatedAvatar)]);

  return (
    <Layout person={personData} />
  );
}
